import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  breakpointSizes,
  fluidFontSize,
  fontSize,
  fontWeights,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, Svg } from './ui';
import quotemarks from '../images/quotemarks.inline.svg';

const StyledTestimonial = styled.section`
  ${sectionPaddings()};
  background-color: ${brandColours.quaternary};
  color: ${standardColours.white};
`;

const StyledInner = styled.figure`
  margin: 0;
`;

const StyledQuotemarks = styled(Svg)`
  width: 36px;
  height: 24px;
  fill: ${standardColours.white};

  ${minBreakpointQuery.small`
    width: 54px;
    height: 32px;
  `}

  ${minBreakpointQuery.large`
    width: 72px;
    height: 48px;
  `}
`;

const StyledQuote = styled.blockquote`
  margin: 20px 0 40px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
    margin-bottom: 50px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 30px;
    margin-bottom: 60px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 35px;
    margin-bottom: 70px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin-top: 40px;
    margin-bottom: 80px;
  `}
`;

const StyledText = styled.p`
  font-weight: ${fontWeights.semibold};
  line-height: 1.7;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(20)};
  `};

  ${minBreakpointQuery.large`
    ${fontSize(22)};
  `};

  ${minBreakpointQuery.xxlarge`
    ${fontSize(24)};
  `};
`;

const StyledFooter = styled.figcaption`
  display: flex;
  gap: 15px;
  align-items: center;
  justify-items: center;

  ${minBreakpointQuery.small`
    gap: 20px;
  `}

  ${minBreakpointQuery.large`
    gap: 25px;
  `}
`;

const StyledImage = styled(GatsbyImage)`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  flex-shrink: 0;

  ${minBreakpointQuery.small`
    width: 75px;
    height: 75px;
  `}

  ${minBreakpointQuery.large`
    width: 100px;
    height: 100px;
  `}
`;

const StyledCite = styled.cite`
  display: block;
  font-style: normal;
  ${fluidFontSize(
    '20px',
    '30px',
    breakpointSizes.tiny,
    breakpointSizes.xxxxlarge,
  )};
`;

const StyledRole = styled.span`
  display: block;
  font-style: normal;
  ${fontSize(16)};
`;

const Testimonial = ({ item }) => {
  if (item) {
    const { quote, image, author, role } = item;

    return (
      <StyledTestimonial>
        <Container>
          <StyledInner>
            <StyledQuotemarks image={quotemarks} />
            <StyledQuote>
              <StyledText>{quote}</StyledText>
            </StyledQuote>
            <StyledFooter>
              <StyledImage image={image.gatsbyImageData} alt={image.alt} />
              <StyledCite>
                {author}
                <StyledRole>{role}</StyledRole>
              </StyledCite>
            </StyledFooter>
          </StyledInner>
        </Container>
      </StyledTestimonial>
    );
  }
};

export default Testimonial;
